import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Component from "./component";

const mapStateToProps = ({
    rtoInfo: {
        cms,
        faqList,
        stateList
    },
    experiments: {
        statsigDynamicConfig: {
            data: statsigDynamicConfigData
        },
        websiteAdvertisementBanner: {
            data: websiteAdvertisementBannerData
        }
    }
}) => ({
    cms,
    faqList,
    stateList,
    statsigDynamicConfigData,
    websiteAdvertisementBannerData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));
